import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Register from '../Pages/Register';
import ThankYou from '../Pages/ThankYou';

function RegisterRoute() {
    return(
        <BrowserRouter>
            <Route path="/register" exact component={Register}/>
            <Route path="/thank-you" component={ThankYou} />
        </BrowserRouter>
    )
}

export default RegisterRoute;
